import { t } from "@/i18n-js/instance";
import { Background } from "@circle-react/components/OnboardingComponents/Background";
import { CommunityImage } from "@circle-react/components/OnboardingComponents/CommunityImage";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { PoweredByCircle } from "@circle-react-shared/PoweredByCircle";
import { Alert } from "@circle-react-shared/uikit/AlertV2";

interface ResetPasswordLayoutProps {
  community?: any;
  isNarrow?: boolean;
  children?: any;
  title: string;
  communityName?: string;
  userEmail?: string;
  otherCommunityNames?: string[] | null;
  withCircleBranding?: boolean;
  shouldShowPoweredByCircle?: boolean;
  canCurrentCommunitySupportCustomLogin?: boolean;
}

export const ResetPasswordLayout = ({
  community,
  isNarrow,
  children,
  title,
  userEmail,
  communityName,
  otherCommunityNames,
  withCircleBranding = true,
  shouldShowPoweredByCircle,
  canCurrentCommunitySupportCustomLogin,
}: ResetPasswordLayoutProps) => {
  const communitySlug = community?.slug;

  const alertTitle = canCurrentCommunitySupportCustomLogin
    ? t("reset_password_otp_login_alert_title", {
        community_name: communityName,
        user_email: userEmail,
      })
    : t("reset_password_otp_login_alert_title_without_community", {
        user_email: userEmail,
      });

  const constructWarning = () => {
    if (otherCommunityNames && otherCommunityNames.length > 0) {
      const communitiesList = otherCommunityNames
        .map(name => `<li>${name}</li>`)
        .join("");
      const message = t("reset_password_otp_login_alert_description", {
        community_name: communityName,
        user_email: userEmail,
      });
      return `${message}<ul class="list-disc">${communitiesList}</ul>`;
    }
    return "";
  };

  return (
    <div
      className={classNames(
        "text-dark flex min-h-screen w-full items-center justify-center",
        {
          "bg-primary md:bg-secondary": !withCircleBranding,
        },
      )}
    >
      <div
        className={classNames("my-4 w-full", {
          "max-w-[450px]": isNarrow,
          "max-w-[520px]": !isNarrow,
        })}
      >
        <div className="md:bg-primary md:border-primary m-auto flex w-full flex-col items-center p-6 py-10 md:rounded-2xl md:border md:p-12">
          <CommunityImage
            community={community}
            withCircleBranding={withCircleBranding}
          />
          <h1 className="mt-8 text-center text-2xl font-bold">{title}</h1>
          <div className="mt-4 w-full">
            <Alert
              title={alertTitle}
              description={
                <div dangerouslySetInnerHTML={{ __html: constructWarning() }} />
              }
              showIcon={false}
              type="info"
            />
          </div>
          <div className="mt-2 w-full">{children}</div>
        </div>

        {shouldShowPoweredByCircle && (
          <div className="md:mt-2">
            <PoweredByCircle
              className="justify-center"
              communitySlug={communitySlug}
            />
          </div>
        )}
      </div>
      {withCircleBranding && <Background isNarrow={isNarrow} />}
    </div>
  );
};
